type PageElement =
  | HTMLElement
  | { pagePath: string; pageUrl: string; pageReferrer: string; pageTitle: string };

export type Operator =
  | 'eq'
  | 'not eq'
  | 'contains'
  | 'not contains'
  | 'is empty'
  | 'is not empty'
  | 'starts with'
  | 'ends with';

function checkValueByOp(op: Operator, value: string, assetValue: string = '') {
  const valueStr = value;
  switch (op) {
    case 'eq':
      return valueStr === assetValue;
    case 'not eq':
      return valueStr !== assetValue;
    case 'contains':
      return valueStr.includes(assetValue);
    case 'not contains':
      return !valueStr.includes(assetValue);
    case 'is empty':
      return !valueStr || valueStr.trim() === '';
    case 'is not empty':
      return !!valueStr && valueStr.trim() !== '';
    case 'starts with':
      return valueStr.startsWith(assetValue);
    case 'ends with':
      return valueStr.endsWith(assetValue);
    default:
      return false;
  }
}

function checkConditions(element: PageElement, conditions: any, debug?: boolean) {
  return conditions.some((condition) => {
    const { tag_key, tag_value } = condition;
    const key = tag_key.value[0];
    const value = tag_value.value[0];
    const op = tag_value.op;

    let elementValue = element[key] || '';

    return checkValueByOp(op, elementValue, value);
  });
}

export function evaluateRules(element: any, rules: any, debug?: boolean) {
  // Evaluate mapping_rules
  function evaluateMappingRules(element: PageElement, eventType: string, mappingRules: any) {
    if (!mappingRules.length) return false;
    return mappingRules.every((ruleGroup) => checkConditions(element, ruleGroup, debug));
  }

  if (rules.length !== 1) return false;

  return rules.every((ruleSet) =>
    ruleSet.some((rule) => {
      const { mapping_rules, metadata, value } = rule;
      const eventType = value[0];
      if (
        eventType.toLowerCase().startsWith('conviva_') &&
        eventType.toLowerCase().endsWith('_click')
      ) {
        return evaluateMappingRules(element, eventType, mapping_rules);
      }
      return false;
    }),
  );
}
